module.exports = __webpack_public_path__ + "static/media/arrowLeft.59a706d6.svg";